import { WorkspaceTabBar as View } from 'ui-components'

import { useIsWorkspaceMember } from '~workspace/hooks/useIsWorkspaceMember'
import { useIsWorkspaceOwner } from '~workspace/hooks/useIsWorkspaceOwner'
import {
  useGetCurrentWorkspace,
  useGetCurrentWorkspaceGuests,
  useGetCurrentWorkspaceInvitedUsers,
  useGetCurrentWorkspaceMembers
} from '~workspace/queries/useGetWorkspaceById'
import { useSearchMapsInCurrentWorkspace } from '~workspace/queries/useSearchMaps'

const TabBar = () => {
  const { data: searchMapsData } = useSearchMapsInCurrentWorkspace()
  const { isLoading } = useGetCurrentWorkspace()
  const isWorkspaceOwner = useIsWorkspaceOwner()
  const isWorkspaceMember = useIsWorkspaceMember()
  const members = useGetCurrentWorkspaceMembers()
  const guests = useGetCurrentWorkspaceGuests()
  const invitedUsers = useGetCurrentWorkspaceInvitedUsers()

  return (
    <View
      canAccessWorkspaceMember={isWorkspaceMember}
      canUpdateWorkspaceSettings={isWorkspaceOwner}
      totalMaps={searchMapsData?.total || 0}
      totalMembers={members.length + guests.length + invitedUsers.length}
      loading={isLoading}
    />
  )
}

export { TabBar }
